<template>
	<div class='items'>
		<div v-if='page > 1' class='items_group_pagination items_group_pagination_prev' @click='onPrevPage()'>
			<svg class="multi-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
				<path class="multi-svg-path" d="M25.3 34.7L15.6 25l9.7-9.7 1.4 1.4-8.3 8.3 8.3 8.3z"></path>
				<path class="multi-svg-path" d="M17 24h17v2H17z"></path>
			</svg>
		</div>
		<div v-for='(items,index_item_group) in items_group' v-bind:key="'item_group_'+index_item_group" class='items_group'>
			<item-component :items='items'></item-component>
		</div>
		<div v-if='category  && category.count > currentCount' class='items_group_pagination items_group_pagination_next' @click='onNextPage()'>
			<svg class="multi-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
				<path class="multi-svg-path" d="M24.7 34.7l-1.4-1.4 8.3-8.3-8.3-8.3 1.4-1.4 9.7 9.7z"></path>
				<path class="multi-svg-path" d="M16 24h17v2H16z"></path>
			</svg>
		</div>
	</div>
</template>

<script>
	import ItemComponent from './ItemComponent.vue'

	export default {
		name: "CellComponent",
		props: ['items_group', 'onNextPage', 'onPrevPage', 'category', 'page', 'size'],
		components: {ItemComponent},
		computed: {
			currentCount() {
				switch (this.size) {
					case 'l':
						return this.page * 13;
					case 'm':
						return this.page * 8;
					case 's':
						return this.page * 4;
				}
			}
		},
	}
</script>

<style scoped lang='scss'>
	.items
	{
		display: flex;
		justify-content: flex-start;
		position: relative;
		&_group
		{
			position: relative;
			min-height: 460px;
			margin: 0 30px 20px 0;
			width: 30%;
			&_pagination
			{
				width: 50px;
				height: 50px;
				cursor: pointer;
				border: 1px solid black;
				border-radius: 50%;
				opacity: 0.7;
				position: absolute;
				right: 0;
				bottom: 15px;
				z-index: 10;
				&_next
				{
					right: 10px;
				}
				&_prev
				{
					left: 10px;
				}
			}

		}
	}

	@media screen and (max-width: 1300px)
	{
		.items
		{
			&_group
			{
				width: 49%;
				min-height: 650px;
			}
		}
	}

	@media screen and (max-width: 900px)
	{
		.items
		{
			&_group
			{
				width: 99%;
				min-height: 450px;
			}
		}
	}

	@media screen and (max-width: 680px)
	{
		.items
		{
			&_group
			{
				min-height: 500px;
				margin: 0 15px;
			}
		}
	}
</style>